import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

const routeLabels: Record<string, string> = {
  dashboard: 'Dashboard',
  map: 'Live Map',
  missions: 'Missions',
  analytics: 'Analytics',
  geofences: 'Geofences',
  sensors: 'Sensors',
  settings: 'Settings',
  admin: 'Admin',
};

export default function Breadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  return (
    <nav className="flex items-center gap-1.5 text-sm">
      <Link to="/dashboard" className="text-gray-500 hover:text-gray-300 transition-colors">
        <HomeIcon className="h-4 w-4" />
      </Link>
      {segments.map((segment, index) => {
        const path = '/' + segments.slice(0, index + 1).join('/');
        const isLast = index === segments.length - 1;
        const label = routeLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);

        return (
          <span key={path} className="flex items-center gap-1.5">
            <ChevronRightIcon className="h-3 w-3 text-gray-600" />
            {isLast ? (
              <span className="text-accent font-medium">{label}</span>
            ) : (
              <Link to={path} className="text-gray-400 hover:text-gray-200 transition-colors">
                {label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
